"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNetworkProvider = exports.NetworkProvider = exports.NetworkContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const out_1 = require("@multiversx/sdk-network-providers/out");
const network_1 = require("../network");
const useAuth_1 = require("../useAuth");
// @ts-ignore
exports.NetworkContext = (0, react_1.createContext)();
const NetworkProvider = ({ networkProvider, env, children }) => {
    const provider = networkProvider !== null && networkProvider !== void 0 ? networkProvider : getNetworkProvider(env !== null && env !== void 0 ? env : "devnet");
    return (0, jsx_runtime_1.jsx)(exports.NetworkContext.Provider, { value: { provider }, children: children });
};
exports.NetworkProvider = NetworkProvider;
const useNetworkProvider = () => {
    const context = (0, react_1.useContext)(exports.NetworkContext);
    if (context !== undefined && context.provider !== undefined) {
        return context.provider;
    }
    // If this is used outside Network Context Provider, we'll assume
    // that the Auth Context is available and we'll try to get the env property.
    const authContext = (0, react_1.useContext)(useAuth_1.AuthContext);
    let env = "devnet";
    if (authContext !== undefined && authContext.env !== undefined) {
        env = authContext.env;
    }
    return getNetworkProvider(env);
};
exports.useNetworkProvider = useNetworkProvider;
const getNetworkProvider = (env) => {
    const url = network_1.network[env]["api"];
    return new out_1.ApiNetworkProvider(url);
};
